import { useRef } from "react";
import ModalPop from "../../home/ModalPop";

const RightQuick = () => {
  const popupRef = useRef<HTMLDivElement>(null);

  const openfunc = () => {
    popupRef.current!.style.display = "block";
  };

  const closefunc = () => {
    popupRef.current!.style.display = "none";
  };
  return (
    <>
      <div className="hidden lg:block fixed right-10 top-1/3 -translate-y-32 w-fit h-fit z-10">
        <div className="grid gap-3">
          <button
            type="button"
            onClick={() => window.open("https://open.kakao.com/o/s3yG7m0h")}
            className=" relative w-fit h-fit max-w-20 rounded-full hover:-translate-y-2 transition-transform duration-200 hover:shadow-md"
          >
            <img src="/images/iconkakao2.webp" alt="비우고 채우고 카카오톡 상담" loading="lazy" className="!relative w-full h-full object-contain" />
          </button>
          <button
            type="button"
            onClick={() => window.open("https://blog.naver.com/cjs43377")}
            className=" relative w-fit h-fit max-w-20 hover:-translate-y-2 transition-transform duration-200 hover:shadow-md rounded-full"
          >
            <img src="/images/iconBlog.webp" alt="비우고 채우고 네이버 블로그" loading="lazy" className="!relative w-full h-full object-contain" />
          </button>
          <button
            type="button"
            onClick={() => {
              window.location.href = "tel:010-5229-1437";
            }}
            className=" relative w-fit h-fit max-w-20 hover:-translate-y-2 transition-transform duration-200 hover:shadow-md rounded-lg"
          >
            <img src="/images/iconCall.webp" alt="비우고 채우고 전화 상담 010-5229-1437" loading="lazy" className="!relative w-full h-full object-contain" />
          </button>
          <button
            type="button"
            onClick={openfunc}
            className=" relative w-fit h-fit max-w-20 hover:-translate-y-2 transition-transform duration-200 hover:shadow-md rounded-lg"
          >
            <img src="/images/iconContact.webp" alt="비우고 채우고 견적 문의" loading="lazy" className="!relative w-full h-full object-contain" />
          </button>
        </div>
      </div>
      <ModalPop popupRef={popupRef} closefnc={closefunc} />
    </>
  );
};

export default RightQuick;
